import React, { FC } from "react";
import slugify from "slugify";

import SectionWithTitle from "src/components/SectionWithTitle";
import SchemaLink from "src/components/index/schemas/SchemaLink";
import {
  UserOrOrg,
  Subject,
  PropertyQuery,
  SubjectQuery,
} from "src/lib/graphql/types";

const MetaTitle: FC = ({ children }) => (
  <div className="field-label">{children}</div>
);

const MetaSection: FC = ({ children }) => (
  <div className="metadata-field">{children}</div>
);

function getHref(
  owner: Pick<UserOrOrg, "shortname"> | undefined
): string | undefined {
  if (!owner?.shortname) {
    return;
  }

  const slug = slugify(owner?.shortname || "");

  return `/@${slug}`;
}

const SchemaMeta: FC<{
  schema: Pick<
    SubjectQuery["subject"] | PropertyQuery["property"],
    "owner" | "updatedAt"
  > & {
    license?: Subject["license"];
  };
}> = ({ schema }) => (
  <SectionWithTitle title="Meta">
    <MetaSection>
      <MetaTitle>Last updated</MetaTitle>
      on {schema.updatedAt.split("T")[0]}
    </MetaSection>
    {schema.owner ? (
      <MetaSection>
        <MetaTitle>Published by</MetaTitle>
        <SchemaLink href={getHref(schema.owner)}>
          {"fullName" in schema.owner
            ? schema.owner.fullName
            : schema.owner.name}
        </SchemaLink>
      </MetaSection>
    ) : null}
    {schema.license ? (
      <MetaSection>
        <MetaTitle>Licensed under</MetaTitle>
        <SchemaLink
          href={schema.license.url}
          end={
            <>
              <br />
              <img
                src={schema.license.logo}
                className="schema-license-logo"
                alt={`Details on the ${schema.license.name} license`}
              />
            </>
          }
        >
          {schema.license.name}
        </SchemaLink>
      </MetaSection>
    ) : null}
  </SectionWithTitle>
);

export default SchemaMeta;
